import React, { useState, useEffect } from "react";

// ── Landing Radar Chart (SVG) ──
const dimensions = [
  { label: "Odak", angle: -90 },
  { label: "Disiplin", angle: -18 },
  { label: "Hafıza", angle: 54 },
  { label: "Tutarlılık", angle: 126 },
  { label: "Motivasyon", angle: 198 },
];
const values = [0.82, 0.65, 0.74, 0.58, 0.91];

function toXY(angleDeg: number, r: number, cx: number, cy: number) {
  const rad = (angleDeg * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}

function RadarChart({ tick }: { tick: number }) {
  const cx = 200, cy = 200, maxR = 140;
  const levels = [0.25, 0.5, 0.75, 1.0];
  const dataPoints = dimensions.map((d, i) => {
    const v = values[i] * (1 + Math.sin(Date.now() / 800 + i) * 0.04);
    return toXY(d.angle, v * maxR, cx, cy);
  });
  const polygon = dataPoints.map(p => `${p.x},${p.y}`).join(" ");
  return (
    <svg viewBox="0 0 400 400" style={{ width: '100%', maxWidth: 384, margin: '0 auto', filter: "drop-shadow(0 0 32px rgba(45,212,191,0.3))" }}>
      <defs>
        <radialGradient id="rgFill2" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#2DD4BF" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#2DD4BF" stopOpacity="0.05" />
        </radialGradient>
        <filter id="glow2"><feGaussianBlur stdDeviation="3" result="blur" /><feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge></filter>
      </defs>
      {levels.map((l, li) => {
        const pts = dimensions.map(d => { const p = toXY(d.angle, l * maxR, cx, cy); return `${p.x},${p.y}`; }).join(" ");
        return <polygon key={li} points={pts} fill="none" stroke={li === 3 ? "#2DD4BF" : "#30363D"} strokeWidth={li === 3 ? 1 : 0.5} strokeOpacity={li === 3 ? 0.5 : 0.4} />;
      })}
      {dimensions.map((d, i) => { const end = toXY(d.angle, maxR, cx, cy); return <line key={i} x1={cx} y1={cy} x2={end.x} y2={end.y} stroke="#30363D" strokeWidth="0.5" strokeOpacity="0.6" />; })}
      <polygon points={polygon} fill="url(#rgFill2)" stroke="#2DD4BF" strokeWidth="2" strokeOpacity="0.9" filter="url(#glow2)" />
      {dataPoints.map((p, i) => (<g key={i}><circle cx={p.x} cy={p.y} r="6" fill="#0B0E14" stroke="#2DD4BF" strokeWidth="2" filter="url(#glow2)" /><circle cx={p.x} cy={p.y} r="2.5" fill="#2DD4BF" /></g>))}
      {dimensions.map((d, i) => { const lp = toXY(d.angle, maxR + 26, cx, cy); return <text key={i} x={lp.x} y={lp.y} textAnchor="middle" dominantBaseline="middle" fontSize="11" fontFamily="'Lexend', sans-serif" fill="#FDE047" opacity="0.9">{d.label}</text>; })}
      <circle cx={cx} cy={cy} r="4" fill="#FDE047" opacity="0.8" filter="url(#glow2)" />
    </svg>
  );
}

function Waveform() {
  const points = Array.from({ length: 40 }, (_, i) => { const x = i * 5; const y = 20 + Math.sin(i * 0.7) * 10 + Math.sin(i * 1.4) * 5; return `${x},${y}`; }).join(" ");
  return <svg viewBox="0 0 200 40" style={{ width: '100%', height: 32 }}><polyline points={points} fill="none" stroke="#2DD4BF" strokeWidth="1.5" opacity="0.8" /></svg>;
}

function LoginModal({ onClose, onLoginSuccess }: { onClose: () => void; onLoginSuccess: (id: string) => void }) {
  const [studentId, setStudentId] = useState("");
  const [password, setPassword] = useState("");
  const [focused, setFocused] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (studentId.trim()) {
      onLoginSuccess(studentId.trim());
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-end" onClick={onClose}>
      <div
        className="h-full w-full max-w-md flex flex-col justify-center px-10 py-12 relative"
        style={{ background: "rgba(22,27,34,0.97)", backdropFilter: "blur(24px)", borderLeft: "1px solid #30363D", boxShadow: "-20px 0 80px rgba(45,212,191,0.08)" }}
        onClick={e => e.stopPropagation()}
      >
        <button onClick={onClose} className="absolute top-6 right-6 text-gray-500 hover:text-white transition-colors text-xl">✕</button>
        <div className="mb-10">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-6" style={{ background: "linear-gradient(135deg,#2DD4BF22,#FDE04722)", border: "1px solid #2DD4BF44" }}>
            <span className="text-lg font-bold" style={{ color: "#2DD4BF" }}>Y</span>
          </div>
          <h2 className="text-2xl font-bold text-white mb-1" style={{ fontFamily: "'Lexend',sans-serif" }}>Tekrar Hoş Geldin</h2>
          <p className="text-sm text-gray-500">EduOS'a bağlan, yolculuğunu sürdür.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          {[
            { label: "Öğrenci ID", type: "text", value: studentId, set: setStudentId, name: "studentId", placeholder: "student_demo" },
            { label: "Şifre", type: "password", value: password, set: setPassword, name: "password", placeholder: "••••••••" },
          ].map(f => (
            <div key={f.name}>
              <label className="block text-xs text-gray-500 mb-2 uppercase tracking-widest">{f.label}</label>
              <input type={f.type} value={f.value} onChange={e => f.set(e.target.value)} onFocus={() => setFocused(f.name)} onBlur={() => setFocused("")} placeholder={f.placeholder}
                className="w-full px-4 py-3 rounded-xl text-white text-sm outline-none transition-all duration-300"
                style={{ background: "#0B0E14", border: `1px solid ${focused === f.name ? "#2DD4BF" : "#30363D"}`, boxShadow: focused === f.name ? "0 0 0 3px rgba(45,212,191,0.12)" : "none", fontFamily: "'Lexend',sans-serif" }}
              />
            </div>
          ))}
          <button type="submit" className="mt-8 w-full py-3.5 rounded-xl text-sm font-semibold transition-all duration-300 hover:scale-[1.02]"
            style={{ background: "linear-gradient(135deg,#2DD4BF,#14b8a6)", color: "#0B0E14", fontFamily: "'Lexend',sans-serif", boxShadow: "0 0 24px rgba(45,212,191,0.3)" }}>
            Sisteme Giriş Yap
          </button>
        </form>
        <button onClick={() => { onLoginSuccess('student_demo'); }} className="mt-4 w-full py-3 rounded-xl text-sm font-medium transition-all duration-300 hover:scale-[1.01]"
          style={{ background: "rgba(253,224,71,0.08)", border: "1px solid #FDE04744", color: "#FDE047", fontFamily: "'Lexend',sans-serif" }}>
          ⚡ Demo Giriş
        </button>
      </div>
    </div>
  );
}

// ── Main Landing Page ──
export default function NewLandingPage({ isLoggedIn, onLogin, onDashboard, onExplore, onLoginSuccess }: {
  isLoggedIn: boolean; onLogin: () => void; onDashboard: () => void; onExplore: () => void; onLoginSuccess: (id: string) => void;
}) {
  const [showModal, setShowModal] = useState(false);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 60);
    return () => clearInterval(id);
  }, []);

  const cards = [
    {
      icon: "💬", title: "Psikolojik Bağ", sub: "Duygusal Zekâ Motoru", color: "#2DD4BF",
      desc: "Yapay zekâ, öğrencinin ruh halini, motivasyon düşüşlerini ve kaygı örüntülerini anlık olarak analiz eder.",
      ui: (
        <div className="space-y-2 mt-4">
          {[{ who: "Sen", msg: "Bugün odaklanamıyorum.", align: "right" as const }, { who: "AI", msg: "Tutarlılık skoru 3 gündür düşüyor. Mikro-mola öneriyorum.", align: "left" as const }].map((b, i) => (
            <div key={i} className={`flex ${b.align === "right" ? "justify-end" : "justify-start"}`}>
              <div className="px-3 py-2 rounded-xl text-xs max-w-[80%]" style={{ background: b.align === "right" ? "rgba(253,224,71,0.15)" : "rgba(45,212,191,0.12)", border: `1px solid ${b.align === "right" ? "#FDE04744" : "#2DD4BF44"}`, color: b.align === "right" ? "#FDE047" : "#2DD4BF", fontFamily: "'Lexend',sans-serif" }}>{b.msg}</div>
            </div>
          ))}
        </div>
      ),
    },
    {
      icon: "🔬", title: "Hakikat Radarı", sub: "Truth Engine™", color: "#FDE047",
      desc: "Öğrencinin öz-değerlendirmesi ile gerçek davranışı arasındaki çelişkileri 49 boyutta tespit eder.",
      ui: (
        <div className="mt-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500" style={{ fontFamily: "'Lexend',sans-serif" }}>Truth Score</span>
            <span className="text-lg font-bold" style={{ color: "#FDE047", fontFamily: "'Lexend',sans-serif" }}>0.62</span>
          </div>
          <Waveform />
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg" style={{ background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)" }}>
            <div className="w-2 h-2 rounded-full animate-pulse" style={{ background: "#ef4444" }} />
            <span className="text-xs" style={{ color: "#ef4444", fontFamily: "'Lexend',sans-serif" }}>Çelişki Tespit Edildi — M9</span>
          </div>
        </div>
      ),
    },
    {
      icon: "⚡", title: "Mikro-Görevler", sub: "Davranış Motoru", color: "#a78bfa",
      desc: "Her analiz sonrası sistem, öğrenciyi dönüştürmek için kişiselleştirilmiş mikro-görevler oluşturur.",
      ui: (
        <div className="mt-4 space-y-2">
          {[{ task: "25 dk Derin Odak Seansı", xp: "+40 XP", done: true }, { task: "Yansıma Günlüğü Yaz", xp: "+25 XP", done: false }].map((t, i) => (
            <div key={i} className="flex items-center gap-3 px-3 py-2 rounded-xl" style={{ background: "rgba(167,139,250,0.08)", border: "1px solid rgba(167,139,250,0.2)" }}>
              <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: t.done ? "#a78bfa" : "transparent", border: t.done ? "none" : "1px solid #a78bfa44" }}>
                {t.done && <span className="text-xs text-black">✓</span>}
              </div>
              <span className="text-xs flex-1 text-gray-300" style={{ fontFamily: "'Lexend',sans-serif" }}>{t.task}</span>
              <span className="text-xs font-bold" style={{ color: "#FDE047", fontFamily: "'Lexend',sans-serif" }}>{t.xp}</span>
            </div>
          ))}
          <div className="mt-2">
            <div className="flex justify-between text-xs mb-1">
              <span className="text-gray-600" style={{ fontFamily: "'Lexend',sans-serif" }}>Seviye 7</span>
              <span className="text-gray-600" style={{ fontFamily: "'Lexend',sans-serif" }}>2,340 / 3,000 XP</span>
            </div>
            <div className="h-1.5 rounded-full" style={{ background: "#30363D" }}>
              <div className="h-1.5 rounded-full" style={{ width: "78%", background: "linear-gradient(90deg,#a78bfa,#2DD4BF)", boxShadow: "0 0 8px rgba(167,139,250,0.5)" }} />
            </div>
          </div>
        </div>
      ),
    },
  ];

  const flowSteps = [
    { icon: "💬", label: "Sohbet", sub: "Öğrenci giriş yapar", color: "#2DD4BF" },
    { icon: "🧠", label: "AI Analizi", sub: "49 boyut taranır", color: "#a78bfa" },
    { icon: "📋", label: "Görev", sub: "Kişisel plan oluşur", color: "#FDE047" },
    { icon: "📈", label: "XP & Büyüme", sub: "Davranış dönüşür", color: "#2DD4BF" },
  ];

  const handleAction = () => {
    if (isLoggedIn) { onDashboard(); } else { setShowModal(true); }
  };

  return (
    <div className="min-h-screen relative overflow-x-hidden" style={{ background: "#0B0E14", fontFamily: "'Lexend',sans-serif" }}>
      {/* Background blobs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-20%] left-[-10%] w-[600px] h-[600px] rounded-full opacity-[0.06]" style={{ background: "radial-gradient(circle,#2DD4BF,transparent)", animation: "floatA 12s ease-in-out infinite" }} />
        <div className="absolute top-[30%] right-[-15%] w-[500px] h-[500px] rounded-full opacity-[0.05]" style={{ background: "radial-gradient(circle,#a78bfa,transparent)", animation: "floatB 15s ease-in-out infinite" }} />
        <div className="absolute bottom-[-10%] left-[30%] w-[400px] h-[400px] rounded-full opacity-[0.04]" style={{ background: "radial-gradient(circle,#FDE047,transparent)", animation: "floatA 18s ease-in-out infinite reverse" }} />
        <style>{`
          @keyframes floatA { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(40px,-30px) scale(1.05)} }
          @keyframes floatB { 0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(-30px,40px) scale(1.03)} }
          @keyframes spin-slow { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
          @keyframes pulse-ring { 0%,100%{opacity:0.3;transform:scale(1)} 50%{opacity:0.6;transform:scale(1.04)} }
          .card-glass { background: rgba(22,27,34,0.7); backdrop-filter: blur(20px); border: 1px solid #30363D; transition: all 0.3s ease; }
          .card-glass:hover { border-color: #2DD4BF44; transform: translateY(-4px); box-shadow: 0 20px 60px rgba(45,212,191,0.1); }
          .btn-cta { transition: all 0.3s ease; }
          .btn-cta:hover { transform: scale(1.03); box-shadow: 0 0 48px rgba(45,212,191,0.4) !important; }
        `}</style>
        <svg className="absolute inset-0 w-full h-full opacity-[0.025]" xmlns="http://www.w3.org/2000/svg">
          <defs><pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse"><path d="M 60 0 L 0 0 0 60" fill="none" stroke="#2DD4BF" strokeWidth="0.5" /></pattern></defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      {/* NAV */}
      <nav className="relative z-20 flex items-center justify-between px-6 md:px-12 py-5">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(135deg,#2DD4BF22,#FDE04722)", border: "1px solid #2DD4BF55" }}>
            <span className="text-sm font-bold" style={{ color: "#2DD4BF" }}>Y</span>
          </div>
          <span className="font-bold text-white tracking-tight">YARUKSAI <span style={{ color: "#2DD4BF" }}>EduOS</span></span>
        </div>
        <div className="hidden md:flex items-center gap-8 text-sm text-gray-500">
          {["Özellikler", "Hakikat Radarı", "Fiyatlar", "Blog"].map(l => (
            <span key={l} className="hover:text-white cursor-pointer transition-colors">{l}</span>
          ))}
        </div>
        {isLoggedIn ? (
          <button onClick={onDashboard} className="btn-cta px-5 py-2.5 rounded-xl text-sm font-semibold" style={{ background: "rgba(45,212,191,0.1)", border: "1px solid #2DD4BF55", color: "#2DD4BF", boxShadow: "0 0 20px rgba(45,212,191,0.1)" }}>
            Panelime Git →
          </button>
        ) : (
          <button onClick={() => setShowModal(true)} className="btn-cta px-5 py-2.5 rounded-xl text-sm font-semibold" style={{ background: "rgba(45,212,191,0.1)", border: "1px solid #2DD4BF55", color: "#2DD4BF", boxShadow: "0 0 20px rgba(45,212,191,0.1)" }}>
            Giriş Yap
          </button>
        )}
      </nav>

      {/* HERO */}
      <section className="relative z-10 px-6 md:px-12 pt-16 pb-24">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-16">
            <div className="flex-1 max-w-xl">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-8 text-xs" style={{ background: "rgba(45,212,191,0.08)", border: "1px solid #2DD4BF33", color: "#2DD4BF" }}>
                <div className="w-1.5 h-1.5 rounded-full bg-current animate-pulse" />
                49-Boyutlu Öğrenci Profili · Aktif
              </div>
              <h1 className="text-4xl md:text-5xl xl:text-6xl font-extrabold text-white leading-[1.1] mb-6" style={{ letterSpacing: "-0.03em" }}>
                Eğitimin{" "}<span style={{ color: "#2DD4BF", textShadow: "0 0 40px rgba(45,212,191,0.4)" }}>Zekâ</span>{" "}ile <br />
                <span style={{ color: "#FDE047", textShadow: "0 0 40px rgba(253,224,71,0.3)" }}>Mizanı</span>
              </h1>
              <p className="text-lg text-gray-400 leading-relaxed mb-4" style={{ fontWeight: 300 }}>Kendini Keşfet, İradeni İnşa Et.</p>
              <p className="text-sm text-gray-600 leading-relaxed mb-10 max-w-sm">Yapay zekâ, öğrencinin gerçek davranışını 49 boyutta analiz eder — öz-farkındalık yanılsamasını kırarak kalıcı dönüşümü başlatır.</p>
              <div className="flex flex-wrap gap-4">
                <button onClick={handleAction} className="btn-cta px-7 py-3.5 rounded-xl text-sm font-bold" style={{ background: "linear-gradient(135deg,#2DD4BF,#14b8a6)", color: "#0B0E14", boxShadow: "0 0 32px rgba(45,212,191,0.35)" }}>
                  {isLoggedIn ? "Panelime Git →" : "Ücretsiz Başla →"}
                </button>
                <button onClick={isLoggedIn ? () => { localStorage.removeItem('edudos_student_id'); window.location.reload(); } : () => onExplore()} className="px-7 py-3.5 rounded-xl text-sm font-medium text-gray-400 hover:text-white transition-colors" style={{ border: "1px solid #30363D" }}>
                  {isLoggedIn ? "Çıkış Yap" : "Demo İzle"}
                </button>
              </div>
              <div className="flex gap-8 mt-12 pt-8" style={{ borderTop: "1px solid #30363D" }}>
                {[["12K+", "Öğrenci"], ["94%", "Dönüşüm"], ["49", "Boyut"]].map(([n, l]) => (
                  <div key={l}><div className="text-2xl font-bold text-white" style={{ fontVariantNumeric: "tabular-nums" }}>{n}</div><div className="text-xs text-gray-600 mt-0.5">{l}</div></div>
                ))}
              </div>
            </div>
            <div className="flex-1 flex flex-col items-center gap-6">
              <div className="relative w-full max-w-sm">
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <div className="w-64 h-64 rounded-full" style={{ border: "1px solid rgba(45,212,191,0.15)", animation: "pulse-ring 3s ease-in-out infinite" }} />
                  <div className="absolute w-80 h-80 rounded-full" style={{ border: "1px solid rgba(45,212,191,0.07)", animation: "pulse-ring 3s ease-in-out infinite 1s" }} />
                </div>
                <div style={{ animation: "spin-slow 30s linear infinite" }}>
                  <RadarChart tick={tick} />
                </div>
                <div className="absolute top-2 right-2 px-2.5 py-1 rounded-lg text-xs font-bold" style={{ background: "rgba(253,224,71,0.1)", border: "1px solid #FDE04744", color: "#FDE047" }}>49D Live</div>
              </div>
              <div className="w-full max-w-sm card-glass rounded-2xl p-5">
                <div className="flex items-center justify-between mb-4">
                  <div><div className="text-xs text-gray-600 uppercase tracking-widest mb-1">Truth Engine™</div><div className="text-sm font-medium text-white">Hakikat Analizi</div></div>
                  <div className="text-right"><div className="text-xs text-gray-600 mb-1">Truth Score</div><div className="text-2xl font-bold" style={{ color: "#FDE047", fontVariantNumeric: "tabular-nums" }}>0.62</div></div>
                </div>
                <Waveform />
                <div className="mt-3 flex items-center gap-2 px-3 py-2.5 rounded-xl" style={{ background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.25)" }}>
                  <div className="w-2 h-2 rounded-full animate-pulse flex-shrink-0" style={{ background: "#ef4444" }} />
                  <div><div className="text-xs font-medium" style={{ color: "#ef4444" }}>Çelişki Tespit Edildi</div><div className="text-xs text-gray-600 mt-0.5">Motivasyon beyanı ↔ davranış verisi — M9 Uyarısı</div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRANSFORMATION FLOW */}
      <section className="relative z-10 px-6 md:px-12 py-24" style={{ borderTop: "1px solid #30363D22" }}>
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-xs text-gray-600 uppercase tracking-widest mb-4">Sistem Akışı</div>
            <h2 className="text-3xl md:text-4xl font-bold text-white" style={{ letterSpacing: "-0.02em" }}>Dönüşüm <span style={{ color: "#2DD4BF" }}>Nasıl</span> Çalışır?</h2>
          </div>
          <div className="flex flex-col md:flex-row items-stretch gap-0">
            {flowSteps.map((s, i) => (
              <div key={i} className="flex flex-col md:flex-row items-center flex-1">
                <div className="flex-1 card-glass rounded-2xl p-6 text-center hover:scale-105 transition-transform duration-300 cursor-default">
                  <div className="text-3xl mb-3">{s.icon}</div>
                  <div className="text-sm font-bold text-white mb-1">{s.label}</div>
                  <div className="text-xs text-gray-600">{s.sub}</div>
                </div>
                {i < flowSteps.length - 1 && (
                  <div className="hidden md:flex items-center px-2">
                    <div className="w-12 flex items-center justify-center relative">
                      <div className="h-px w-full" style={{ background: `linear-gradient(90deg,${flowSteps[i].color}44,${flowSteps[i + 1].color}44)` }} />
                      <div className="absolute right-0 text-gray-600">›</div>
                      <div className="absolute w-1.5 h-1.5 rounded-full" style={{ background: s.color, animation: `floatA ${2 + i}s ease-in-out infinite`, boxShadow: `0 0 6px ${s.color}` }} />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PRODUCT CARDS */}
      <section className="relative z-10 px-6 md:px-12 py-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="text-xs text-gray-600 uppercase tracking-widest mb-4">Modüller</div>
            <h2 className="text-3xl md:text-4xl font-bold text-white" style={{ letterSpacing: "-0.02em" }}>Üç Motorde Tam <span style={{ color: "#FDE047" }}>Güç</span></h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {cards.map((c, i) => (
              <div key={i} className="card-glass rounded-2xl p-6 flex flex-col">
                <div className="flex items-start justify-between mb-4">
                  <div><div className="text-2xl mb-2">{c.icon}</div><div className="text-base font-bold text-white">{c.title}</div><div className="text-xs mt-0.5" style={{ color: c.color }}>{c.sub}</div></div>
                  <div className="w-1.5 h-1.5 rounded-full mt-1" style={{ background: c.color, boxShadow: `0 0 8px ${c.color}` }} />
                </div>
                <p className="text-xs text-gray-500 leading-relaxed mb-4 flex-1">{c.desc}</p>
                <div className="rounded-xl p-3" style={{ background: "#0B0E14", border: "1px solid #30363D" }}>{c.ui}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative z-10 px-6 md:px-12 py-24">
        <div className="max-w-3xl mx-auto text-center">
          <div className="card-glass rounded-3xl p-12" style={{ background: "rgba(45,212,191,0.04)", borderColor: "#2DD4BF22" }}>
            <div className="text-xs text-gray-600 uppercase tracking-widest mb-6">Hazır mısın?</div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4" style={{ letterSpacing: "-0.03em" }}>Kendini <span style={{ color: "#2DD4BF" }}>Gerçekten</span> Tanımaya <br />Başla</h2>
            <p className="text-sm text-gray-500 mb-10 max-w-lg mx-auto leading-relaxed">YARUKSAI EduOS, öğrencinin gerçek potansiyelini 49 boyutta ortaya çıkarır. Yanılsamaları bırak, dönüşümü başlat.</p>
            <button onClick={handleAction} className="btn-cta px-10 py-4 rounded-xl font-bold text-sm" style={{ background: "linear-gradient(135deg,#2DD4BF,#14b8a6)", color: "#0B0E14", boxShadow: "0 0 40px rgba(45,212,191,0.3)" }}>
              {isLoggedIn ? "Panelime Git →" : "Ücretsiz Hesap Oluştur →"}
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="relative z-10 px-6 md:px-12 py-8" style={{ borderTop: "1px solid #30363D" }}>
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-sm font-bold text-white">YARUKSAI <span style={{ color: "#2DD4BF" }}>EduOS</span></span>
          <span className="text-xs text-gray-700">© 2025 YARUKSAI. Tüm hakları saklıdır.</span>
          <div className="flex gap-6 text-xs text-gray-700">
            {["Gizlilik", "Koşullar", "İletişim"].map(l => (<span key={l} className="hover:text-gray-400 cursor-pointer transition-colors">{l}</span>))}
          </div>
        </div>
      </footer>

      {/* MODAL */}
      {showModal && <LoginModal onClose={() => setShowModal(false)} onLoginSuccess={(id) => { onLoginSuccess(id); setShowModal(false); }} />}
    </div>
  );
}
